export default __webpack_public_path__ + "static/media/depressed.c9ff7264.svg";